export const isValidListBuilderName = (value: string): boolean =>
    /^[\w\s-]+$/.test(value.trim());

export const isValidListBuilderLocationMinMaxCount = (
    minCount?: number | null,
    maxCount?: number | null,
) => {
    if (
        minCount === undefined ||
        maxCount === undefined ||
        minCount === null ||
        maxCount === null
    ) {
        return true;
    }
    if (minCount > maxCount) {
        return false;
    }
    return true;
};
